export const CUTTING_SNAP_DISTANCE = 200;
export const Z_INDEX_SCISSORS = 9001;
export const Z_INDEX_SCISSORS_HOVER = 9002;
export const EARTH_RADIUS = 6378137;
